<dirty-tracking [forms]="[messageForm]"></dirty-tracking>
<form novalidate #messageForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body p-0">
        <div class="row">
            <div class="col-lg-4">
                <div class="bg-secondary text-white p-3 d-flex align-items-center justify-content-between" style="border-top-left-radius: 30px;">
                    <span class="fs-5">{{userCount()}} users selected</span>
                    <a href="javascript:void(0)" class="text-white text-decoration-underline" (click)="clearList()"><i class="far fa-times"></i> clear list</a>
                </div>
                <div class="notifyList">
                    <ul class="list-group notifySelectedList">
                        <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let user of userList()">
                            <div class="d-flex align-items-center">
                                <div class="me-2" *ngIf="!user.imageUrl">
                                    <div class="avatar avatar-sm">{{user.initials}}</div>
                                </div>
                                <div class="me-2" *ngIf="user.imageUrl">
                                    <div class="avatar avatar-sm" [ngStyle]="{'background-image': user.imageUrl}"></div>
                                </div>
                                <div>
                                    <span class="text-500">{{user.fullName}}</span>
                                    <small class="d-block" *ngIf="user.title">{{user.title}}</small>
                                </div>
                            </div>
                            <a href="javascript:void(0)" class="text-dark" (click)="removeUser(user.userId)"><i class="far fa-times"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="p-3 h-100">
                    <div class="modal-header py-2 px-0 border-0">
                        <h5 class="modal-title">Compose Message</h5>
                        <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
                    </div>
                    <div class="flexGroup">
                        <div class="mt-3">
                            <label for="notifySubject" class="form-label">Title</label>
                            <input type="text" class="form-control form-control-lg" name="notifySubject" placeholder="Subject" [(ngModel)]="newMessage.subject" required>
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="mt-3 notifyMessageWrap">
                            <label for="notifyMessage" class="form-label">Message</label>
                            <ckeditor [editor]="Editor" [(ngModel)]="newMessage.messageText" name="wysiwygValue" [config]="config" #editor></ckeditor>
                            <input type="hidden" name="messageText" class="form-control" required [(ngModel)]="newMessage.messageText" [ngClass]="{'is-invalid': submitAttempt && !newMessage.messageText}" />
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="mt-5 text-right">
                            <button type="button" class="btn btn-outline-black btn-round btn-lg mr-2" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
                            <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-paper-plane"></i> Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>